
import store from '../hooks/hooks.store';

export const API = process.env.REACT_APP_API_URL || "https://savaninvests-backend.onrender.com";

/** Returns the active company id from localstorage or Redux store */
function getActiveCompanyId() {
    const lsCompanyId = localStorage.getItem('activeCompanyId');
    if (lsCompanyId) return lsCompanyId;
    
    const state = store.getState();
    return state?.userReducer?.activeCompany?.id || '';
}

/** Format URL with company_id query parameter if active */
function formatUrl(link) {
    const companyId = getActiveCompanyId();
    if (!companyId || link.includes('company_id=')) return API + link;
    const separator = link.includes('?') ? '&' : '?';
    return `${API}${link}${separator}company_id=${encodeURIComponent(companyId)}`;
}

/** Build common headers, always injecting X-Company-Id if available */
function buildHeaders(tok = '', contentType = true) {
    const companyId = getActiveCompanyId();
    const headers = {
        authorization: "Bearer " + tok,
    };
    if (contentType) headers['Content-Type'] = 'application/json';
    if (companyId) {
        headers['x-company-id'] = companyId;
    }
    return headers;
}

/**
 * POST request
 */
export async function Send(link, data, stringify = true, tok = "") {
    const options = {
        method: 'post',
        headers: buildHeaders(tok, stringify),
        body: stringify ? JSON.stringify(data) : data
    };
    const response = await fetch(formatUrl(link), options);
    if (response.status === 401) {
        store.dispatch({ type: "logout" });
        localStorage.clear();
        window.location.href = '/';
        return { error: 'Session expired' };
    }
    return response.json();
}

/**
 * GET request
 */
export async function Get(link, tok = "") {
    const options = {
        method: 'get',
        headers: buildHeaders(tok),
    };
    const response = await fetch(formatUrl(link), options);
    if (response.status === 401) {
        store.dispatch({ type: "logout" });
        localStorage.clear();
        window.location.href = '/';
        return { error: 'Session expired' };
    }
    return response.json();
}

/**
 * PUT request
 */
export async function Update(link, data, tok = "", stringify = true) {
    const options = {
        method: 'put',
        headers: { ...buildHeaders(tok, stringify), 'Accept': 'application/json' },
        body: stringify ? JSON.stringify(data) : data
    };
    const response = await fetch(formatUrl(link), options);
    if (response.status === 401) {
        store.dispatch({ type: "logout" });
        localStorage.clear();
        window.location.href = '/';
        return { error: 'Session expired' };
    }
    return response.json();
}

/**
 * DELETE request
 */
export async function Remove(link, tok = "") {
    const options = {
        method: 'delete',
        headers: buildHeaders(tok, false),
    };
    const response = await fetch(formatUrl(link), options);
    if (response.status === 401) {
        store.dispatch({ type: "logout" });
        localStorage.clear();
        window.location.href = '/';
        return { error: 'Session expired' };
    }
    return response.json();
}
